module.exports = __webpack_public_path__ + "img/ic-close.ac6e6357.svg";